import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/layer/layer.query.gql"
import type {
  LayerQuery,
  LayerQueryVariables,
} from "@/v2-backoffice-client/layer/__types__/layer.query"

type Options = QueryHookOptions<LayerQuery, LayerQueryVariables>

export function useLayerQuery(options?: Options) {
  return useQuery<LayerQuery, LayerQueryVariables>(query, options)
}
